/* istanbul ignore file */

import React from 'react';
import { getNothsLogoUrl, getStaticFilesEnv } from '@noths/polaris-client-static-files';

import * as styles from './SiteLogo.styles';
import type { Environment } from 'client-site-chrome-ui/environment';

interface SiteLogoProps {
  env: Environment;
}

export const SiteLogo = ({ env = 'production' }: SiteLogoProps) => {
  const staticFilesEnv = getStaticFilesEnv(env);

  return <img alt="" css={styles.image} src={getNothsLogoUrl(staticFilesEnv, '3001')} />;
};
